<!-- <h2 i18n="@@common.coming_soon">Coming Soon</h2> -->
<div class="alert alert-warning w-100" role="alert" *ngIf="labelStatus == 'free_user'; else paid_user">
	<ng-container i18n="@@please_upgrade_your_package_before_dec">
		Please <a href="javascript:;" (click)="goToPlan.emit()"> upgrade your package </a> to continue using the online payment service
	</ng-container>
</div>
<ng-template #paid_user>
	<form [formGroup]="merchantForm">

		<fieldset class="oneThird" [ngClass]="{'has-error': submitted && merchantForm.controls.opay_merchant_id?.errors}">
			<label ><ng-container>Merchant ID</ng-container><span class="req-star">*</span></label>
			<input type="text" [attr.readonly]="userDetails?.payment_model?.opay_merchant_id" formControlName="opay_merchant_id" name="opay_merchant_id" class="mt-1">
			<span i18n="@@error.required" *ngIf="submitted && merchantForm.controls.opay_merchant_id.errors?.required" class="field-error">Secret key is required</span>
			<span class="field-error" *ngIf="submitted && f.opay_merchant_id.errors?.serverError">{{ f.opay_merchant_id.errors?.serverError }}</span>
		</fieldset>

		<fieldset class="oneThird" [ngClass]="{'has-error': submitted && merchantForm.controls.opay_public_key?.errors}">
			<label ><ng-container>Public Key</ng-container><span class="req-star">*</span></label>
			<input type="text" [attr.readonly]="userDetails?.payment_model?.opay_public_key" formControlName="opay_public_key" name="opay_public_key" class="mt-1">
			<span i18n="@@error.required" *ngIf="submitted && merchantForm.controls.opay_public_key.errors?.required" class="field-error">Public key is required</span>
			<span class="field-error" *ngIf="submitted && f.opay_public_key.errors?.serverError">{{ f.opay_public_key.errors?.serverError }}</span>
		</fieldset>

		<fieldset class="oneThird" [ngClass]="{'has-error': submitted && merchantForm.controls.opay_secret_key?.errors}">
			<label ><ng-container>Secret Key</ng-container><span class="req-star">*</span></label>
			<input type="text" [attr.readonly]="userDetails?.payment_model?.opay_secret_key" formControlName="opay_secret_key" name="opay_secret_key" class="mt-1">
			<span i18n="@@error.required" *ngIf="submitted && merchantForm.controls.opay_secret_key.errors?.required" class="field-error">Secret key is required</span>
			<span class="field-error" *ngIf="submitted && f.opay_secret_key.errors?.serverError">{{ f.opay_secret_key.errors?.serverError }}</span>
		</fieldset>

		<div class="account-setting__actionButtonsWrap">
			<button *ngIf="!userDetails?.payment_model?.opay_public_key" type="submit" (click)="onSubmit(merchantForm)" class="tu-btn pink save-btn" i18n="@@button.save">Save</button>
			<button *ngIf="userDetails?.payment_model?.opay_public_key" (click)="deleteMerchant()" type="button" class="tu-btn pink save-btn" i18n="@@ts.common.delete">Delete</button>
		</div>
	</form>
</ng-template>